export const ProductInfo = {
  rwppg: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "BPD:BPH / KSB Submersible Pumps - 200mm",
            src:
              "assets/SubComponentList/1_Raw%20Water%20Pumping/BPD_BPH/KSB%20Submersible%20Pumps%20-%20200mm.jpg"
          },
          {
            name: "Cora - KSB Submersible Pumpset 100mm",
            src:
              "assets/SubComponentList/1_Raw%20Water%20Pumping/Cora/Cora%20-%20KSB%20Submersible%20Pumpset%20100mm.jpg",
            pdfLink: "assets/Catalogues/Cora Catalouge.pdf"
          },
          {
            name: "KSB Submersible Pumpset 150mm",
            src:
              "assets/SubComponentList/1_Raw%20Water%20Pumping/UQD_UMA/KSB%20Submersible%20Pumps%20-%20150mm.png"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      }
    ]
  },
  rwtf: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "Monosub RE",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/Monosub%20RE/monosub-r-data-6.png",
            pdfLink: "assets/Pdf/monosub.pdf"
          },
          {
            name: "Monosub 20RV",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/Monosub%20RV/Monosub%20RV.jpg"
          },
          {
            name: "Monosub Reg D",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/Monosub%20Reg%20D/Monosub%20Reg%20D.jpg"
          },
          {
            name: "Monosub Reg",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/Monosub%20Reg/monosub-r-data-7.png",
            pdfLink: "assets/Pdf/monosub.pdf"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      }
    ]
  },
  rodm: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "ETNC / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETNC / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "Megachem",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Megachem/Megachem.jpg"
          },
          {
            name: "Movitech VCF",
            src:
              "assets/SubComponentList/5_RO%20Plant_DM%20Plant/Movitech/Movitec%20VCF.jpg",
            pdfLink: "assets/Pdf/Movitec.pdf"
          },
          {
            name: "Romoco Fliters",
            src:
              "assets/SubComponentList/5_RO%20Plant_DM%20Plant/Romaco%20Filters/Romoca%20filters%201.png"
          },
          {
            name: "Romoco Fliters 2",
            src:
              "assets/SubComponentList/5_RO%20Plant_DM%20Plant/Romaco%20Filters/Romoca%20filters.png"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "3-Way Flanged Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve / LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png",
            pdfLink: "assets/Pdf/3288.pdf"
          }
        ]
      }
    ]
  },
  chill: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "Etabloc SYT",
            src: "assets/SubComponentList/6_Chillers/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETN / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "Movitech VCF",
            src:
              "assets/SubComponentList/5_RO%20Plant_DM%20Plant/Movitech/Movitec%20VCF.jpg",
            pdfLink: "assets/Pdf/Movitec.pdf"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "3-Way Flanged Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve / LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png",
            pdfLink: "assets/Pdf/3288.pdf"
          }
        ]
      }
    ]
  },
  hexc: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "Etabloc SYT",
            src: "assets/SubComponentList/6_Chillers/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETN / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "Movitech VCF",
            src:
              "assets/SubComponentList/5_RO%20Plant_DM%20Plant/Movitech/Movitec%20VCF.jpg",
            pdfLink: "assets/Pdf/Movitec.pdf"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "BFV Series 20815-830-860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve/LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png",
            pdfLink: "assets/Pdf/3288.pdf"
          }
        ]
      }
    ]
  },
  boil: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "MOVI - High Pressure Mulistage Pumps",
            src:
              "assets/SubComponentList/8_Boilers/MOVI/MOVI%20-%20High%20Pressure%20Mulistage%20Pumps.jpeg",
            pdfLink: "assets/Pdf/MOVI.pdf"
          },
          {
            name: "Movitech VCF",
            src: "assets/SubComponentList/8_Boilers/Movitech/Movitec%20VCF.jpg",
            pdfLink: "assets/Pdf/Movitec.pdf"
          },
          {
            name: "WK:WL High Pressure Multistage Pumps",
            src:
              "assets/SubComponentList/8_Boilers/WK_WL/WK_WL%20-%20High%20Pressure%20Multistage%20Pumps.jpeg",
            pdfLink: "assets/Pdf/WK-WL-Leaflet.pdf"
          }
        ]
      }
    ]
  },
  clts: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "ETB / Etabloc SYT",
            src:
              "assets/SubComponentList/9_Cooling%20Towers/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETN / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "Moviboost V",
            src:
              "assets/SubComponentList/9_Cooling%20Towers/MOVI%20BOOST/Moviboost%20V.jpg",
            pdfLink: "assets/Pdf/MoviBoost.pdf"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "3-Way Flanged Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve / LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png",
            pdfLink: "assets/Pdf/3288.pdf"
          }
        ]
      }
    ]
  },
  rvess: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "CPKOC / Standardised Chemical Pumps",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/CPKOC/CPK%20-%20Standardised%20Chemical%20Pumps.jpg",
            pdfLink: "assets/Pdf/CPKOC.pdf"
          },
          {
            name: "ETNC / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETNC / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "Megachem",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Megachem/Megachem.jpg"
          },
          {
            name: "KWP - Centrifugal Pumps",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/KWP/KWP%20-%20Centrifugal%20Pumps%20(Non%20-%20Clogging).jpg",
            pdfLink: "assets/Pdf/KWP.pdf"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "3-Way Flanged Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve / LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png",
            pdfLink: "assets/Pdf/3288.pdf"
          }
        ]
      }
    ]
  },
  strm: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "ETB / Etabloc SYT",
            src: "assets/SubComponentList/4_Softener/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETNC / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETNC / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "3-Way Flanged Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve / LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png"
          },
          { name: "", src: "", pdfLink: "assets/Pdf/3288.pdf" }
        ]
      }
    ]
  },
  mjcg: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "ETN / Etanorm - SYT",
            src:
              "assets/SubComponentList/12_Machine%20Jacket%20Cooling/ETN/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm - RSY",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "Moviboost V",
            src:
              "assets/SubComponentList/12_Machine%20Jacket%20Cooling/MOVI%20BOOST/Moviboost%20V.jpg",
            pdfLink: "assets/Pdf/MoviBoost.pdf"
          },
          {
            name: "Movitech VCF",
            src:
              "assets/SubComponentList/5_RO%20Plant_DM%20Plant/Movitech/Movitec%20VCF.jpg",
            pdfLink: "assets/Pdf/Movitec.pdf"
          }
        ]
      }
    ]
  },
  sftnr: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "ETB / Etabloc SYT",
            src: "assets/SubComponentList/4_Softener/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETN / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "KMH Model Pump",
            src: "assets/SubComponentList/4_Softener/KMH/KMH%20Model%20Pump.png"
          }
        ]
      },
      {
        name: "BFV",
        items: [
          {
            name: "Series 815-830-860 (Continued)",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860%20(Continued).png"
          },
          {
            name: "Series 815-830-860",
            src:
              "assets/SubComponentList/2_Raw%20Water%20Transfer/BFV/Series%20815-830-860.png"
          },
          {
            name: "Series K815-K830-K860",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20K815-K830-K860.png"
          },
          {
            name: "Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/BFV/Series%20835.png"
          }
        ]
      },
      {
        name: "Metso Valve",
        items: [
          {
            name: "3-Way Flanged Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/3-Way%20Flanged%20Ball%20Valves.png"
          },
          {
            name: "Metso A-Style Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/A-Style%20Ball%20Valves.png"
          },
          {
            name: "Metso ADC Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/ADC-Series.png"
          },
          {
            name: "Metso Valve / LCR-Series",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/LCR-Series.png"
          },
          {
            name: "Metso A-Style Ball Valves ",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Valv-Powr®%20VPVL.png"
          },
          {
            name: "Steam Jacketed Ball Valves",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/Steam%20Jacketed%20Ball%20Valves.png"
          },
          {
            name: "The Eliminator Ball Valve",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/Metso%20Valve/The%20Eliminator%20Ball%20Valve.png",
            pdfLink: "assets/Pdf/3288.pdf"
          }
        ]
      }
    ]
  },
  ecft: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "Ama Porter",
            src:
              "assets/SubComponentList/13_Effluent%20Collection%20Pit/AMA%20Porter/AMA%20Porter.jpg",
            pdfLink: "assets/Pdf/Ama-Porter.pdf"
          },
          {
            name: "Ama Rex",
            src:
              "assets/SubComponentList/13_Effluent%20Collection%20Pit/Ama%20Rex/Amarex%20N.jpg",
            pdfLink: "assets/Pdf/Amarex.pdf"
          }
        ]
      },
      {
        name: "Ama Drainer",
        items: [
          {
            name: "Ama Drainer 300 Series",
            src:
              "assets/SubComponentList/16_Canteen_Utility_Store_Rooms/Ama%20Drainer/AMA%20Drainer%20300%20series.jpeg",
            pdfLink: "assets/Pdf/Ama-Drainer.pdf"
          },
          {
            name: "Ama Drainer 400 Series",
            src:
              "assets/SubComponentList/16_Canteen_Utility_Store_Rooms/Ama%20Drainer/AMA%20Drainer%20400%20series.jpg",
            pdfLink: "assets/Pdf/Ama-Drainer.pdf"
          }
        ]
      }
    ]
  },
  ewtp: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "CPKOC / Standardised Chemical Pumps",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/CPKOC/CPK%20-%20Standardised%20Chemical%20Pumps.jpg",
            pdfLink: "assets/Pdf/CPKOC.pdf"
          },
          {
            name: "KWP - Centrifugal Pumps(Non - Clogging)",
            src:
              "assets/SubComponentList/14_Effluent%20Watertreatment%20Plant/KWP/KWP%20-%20Centrifugal%20Pumps%20(Non%20-%20Clogging).jpg",
            pdfLink: "assets/Pdf/KWP.pdf"
          },
          {
            name: "KRTU Model",
            src:
              "assets/SubComponentList/14_Effluent%20Watertreatment%20Plant/KRTU/KRTU%20Model.jpg",
            pdfLink: "assets/Pdf/KRTU.pdf"
          }
        ]
      }
    ]
  },
  ffet: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "KSB Fire Hydrant Pumpset",
            src:
              "assets/SubComponentList/15_Fire%20Fighting%20Equipment/KSB%20Fire%20Hydrant%20Pumpset.jpg"
          },
          {
            name: "KSB Etaline",
            src:
              "assets/SubComponentList/15_Fire%20Fighting%20Equipment/KSB Fire Equipment-6.png"
          },
          {
            name: "KSB Movitec B",
            src:
              "assets/SubComponentList/15_Fire%20Fighting%20Equipment/KSB Fire Equipment-6-1.png",
            pdfLink: "assets/Pdf/KSB-Fire-Equipment.pdf"
          }
        ]
      }
    ]
  },
  crts: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "Movi Boost V",
            src:
              "assets/SubComponentList/16_Canteen_Utility_Store_Rooms/MOVI%20BOOST/Moviboost%20V.jpg",
            pdfLink: "assets/Pdf/MoviBoost.pdf"
          }
        ]
      },
      {
        name: "Ama Drainer",
        items: [
          {
            name: "Ama Drainer 300 Series",
            src:
              "assets/SubComponentList/16_Canteen_Utility_Store_Rooms/Ama%20Drainer/AMA%20Drainer%20300%20series.jpeg"
          },
          {
            name: "Ama Drainer 400 Series",
            src:
              "assets/SubComponentList/16_Canteen_Utility_Store_Rooms/Ama%20Drainer/AMA%20Drainer%20400%20series%201.jpg",
            pdfLink: "assets/Pdf/Ama-Drainer.pdf"
          }
        ]
      }
    ]
  },
  pstk: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "ETB / Etabloc SYT",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETN / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          }
        ]
      }
    ]
  },
  ldar: {
    categories: [
      {
        name: "Products",
        items: [
          {
            name: "CPKOC / Series 835",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/CPKOC/CPK%20-%20Standardised%20Chemical%20Pumps.jpg",
            pdfLink: "assets/Pdf/CPKOC.pdf"
          },
          {
            name: "ETB / Etabloc SYT",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETB/Etabloc%20SYT.jpg",
            pdfLink: "assets/Pdf/ETB.pdf"
          },
          {
            name: "ETN / Etanorm SYT",
            src:
              "assets/SubComponentList/10_Reactor%20Vessels/ETNC/Etanorm%20-%20SYT/Etanorm%20SYT.jpg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          },
          {
            name: "ETN / Etanorm RSY",
            src:
              "assets/SubComponentList/3_Water%20Treatment%20Plant/ETN/Etanorm%20-%20RSY/Etanorm%20RSY.jpeg",
            pdfLink: "assets/Pdf/ETN-etanorm.pdf"
          }
        ]
      }
    ]
  }
};
